var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-upload", {
    staticClass: "upload-file",
    attrs: {
      action: _vm.action,
      multiple: false,
      "before-upload": _vm.beforeUpload,
      "http-request": _vm.doUpload,
      "show-file-list": false,
      "auto-upload": true,
      accept: _vm.accept,
      disabled: _vm.uploading
    }
  }, [_vm.url ? _c("div", {
    staticClass: "upload-action"
  }, [_c("el-link", {
    attrs: {
      type: "primary",
      underline: false
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.previewFile.apply(null, arguments);
      }
    }
  }, [_vm._v("查看发票")]), _c("span", [_vm._v("更换")])], 1) : _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.uploading,
      expression: "uploading"
    }],
    staticClass: "add"
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };